<template>
  <component :is="tag" class="color badge" :class="`badge bg-${color}`">
    <slot></slot>
  </component>
</template>
<script>
export default {
  name: 'Badge',
  props: {
    tag: {
      type: String,
      default: 'span',
      description: 'Badge tag'
    },
    color: {
      type: String,
      default: 'default',
      // validator: value => {
      //   const acceptedValues = [
      //     'primary',
      //     'success',
      //     'danger',
      //     'warning',
      //     'info',
      //     'light',
      //     'dark',
      //     'red',
      //     'indigo',
      //     'purple',
      //     'pink',
      //     'yellow',
      //     'teal',
      //     'cyan',
      //     'gray',
      //     'blue',
      //     'green',
      //     'default'
      //   ]
      //   return acceptedValues.indexOf(value) !== -1
      // },
      description: 'Badge type (red|indigo|navy|marron|brown|purple|pink|yellow|lime|teal|cyan|black|gray|green|blue|default)'
    }
  }
}
</script>
<style scoped>
div.badge {
  margin-right: 5px;
  margin-left: 5px;
}
.clickable {
  cursor: pointer;
}
.color {
  color: #fff;
}
</style>

